/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var discount_codes = [];
if(document.querySelector('#discount-data')){
   discount_codes = JSON.parse(document.querySelector('#discount-data').textContent);  
}

function apply_discount_code(form=null,totalQty=null){
  let discount_length = discount_codes.length - 1 ;
  var discount = '';
  if(form != null){
    discount = form.find('.discountCode').val();
  }

  if($('.bundle-wrapper-new').length){
    var cartItem = $('#sidebar-cart .CartItemWrapper');
    var cartQty = 0;
    $.each(cartItem, function(){
       let title = $(this).find('.CartItem__Title').text().trim().toLowerCase();
       if(title.includes('stift')){
         cartQty += parseInt($(this).find('[name="updates[]"]').val()); 
       }
    });
    var cartCount = cartQty;
    if(totalQty != null){
      cartCount = cartCount + totalQty;
    }
    
    switch(cartCount){
      case 1:
        discount = discount_codes[0];
        break;
      case 2:
        discount = discount_codes[1];
        break;
      case 3:
        if(discount_codes.hasOwnProperty(2)){
          discount = discount_codes[2];
        }else{
          discount = discount_codes[discount_length];    
        }
        break;
      case 4:
        if(discount_codes.hasOwnProperty(3)){
          discount = discount_codes[3];
        }else{
          discount = discount_codes[discount_length];    
        }
        break;
      case 5:
         if(discount_codes.hasOwnProperty(4)){
          discount = discount_codes[4];
         }else{
           discount = discount_codes[discount_length];
         }
        break;
    }

    if(cartCount > 5){
      discount = discount_codes[discount_length];
    }
    
  
    var code = '';
    if(window.discountOnCartProApp){
      code = window.discountOnCartProApp.codes;  
    }

    console.log(discount, 'discount', cartCount, 'cartCount', 'discount not empty');
    
    setTimeout(function(){
      if(code.length){
        console.log(code, 'removed applied code');
        window.discountOnCartProApp.removeCodes(code);
      }
      
      if(discount != ''){
        
        window.discountOnCartProApp.applyCode(discount);
        
      }
    },1000);
    
  }
}

function sliderInit(){ 
  if(!$('.drawer-upsell').hasClass('flickity-enabled') && $('.drawer-upsell').length){
     $('.drawer-upsell').flickity({
      pageDots: false,
      cellAlign: 'center',
      wrapAround: true,
      draggable: false
    }); 
  }
}

setInterval(function(){
  sliderInit();  
});

// Change cart drawer Cross sell title based on cross sell selected.
$('body').on('click', '.drawer-upsell.flickity-enabled .previous, .drawer-upsell.flickity-enabled .next', function(){
  var ele = $(this);

    var index = ele.closest('.flickity-enabled').find('.upsell-item.is-selected').index();
    var item_index = ele.closest('.flickity-enabled').find('.upsell-item.is-selected').attr('item-index');
    console.log(item_index, 'index');
    if($('.upsell-heading.title-'+item_index).length){
      $('.upsell-heading').hide();
      $('.upsell-heading.title-'+item_index).show();
    }
});

let upsellAdd = (e) => {
  var id = e.getAttribute('data-var-id');
  var custom_Id = e.getAttribute('data-new-var-id');  
  var lineId = [];
  console.log(custom_Id, 'custom_Id');
  if(custom_Id != null && custom_Id != ''){
    
    const ids = custom_Id.split(',').filter(id => id);     
    ids.forEach((id, index) => {      
      const selector = `#boxItem-id${id}`;
      const element = document.querySelector(selector);
      if (element) {
        lineId.push(element.querySelector(".CartItem__Remove").getAttribute('data-var'));
      } 
    });    
  }
  
  let formData = {
    id : id,
    quantity:1
  };
 fetch('/cart/add.js', {
  method: 'POST',
  headers: {
  'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
  })
  .then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
       bubbles: true, 
      detail: {
        quantity: 1
      }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    //if($('.enable-upsell-discount').length){
      setTimeout(function(){
        if(discount_codes.length){ 
          apply_discount_code();
        }  
      }, 1000);
    //}
  
  });   

  if(lineId.length){
    const removeData = lineId.reduce((obj, arrValue) => (obj[arrValue] = 0, obj), {});
    console.log(removeData, 'removeData');
    $.ajax({
      type: 'POST',
      async: false,
      url: '/cart/update.js',
      data: { updates: removeData },
      dataType: 'json'
    });
  }
}

function addTocart(e){ 
  e.preventDefault();
  if($('.Cart__Empty').length){
    setCookie('docapp-auto-coupon','',7);
    setCookie('discount_code','',7);
    setCookie('docapp-coupon','',7);
  }
  
  //console.log(e.target, 'target');
  var items = [];
  var form = $(e.target.closest('form'));
  var totalQty = 0;
  if($('.bundle-wrapper-new').length){
    var selects = $('.qty-wrapper.active .custom-count');
    var selectlength = selects.length;
    for(i=0; i<selectlength; i++){
        var select = selects[i];
        var value = select.getAttribute('data-id');
        if(value != ''){
          items.push({"id": value, "quantity": $(select).val()});
          totalQty += parseInt($(select).val());
        }
    }
  }else{
    var selects = form.find('.select-input');
    var selectlength = selects.length;
    for(i=0; i<selectlength; i++){
        var select = selects[i];
        if(select.value != ''){
          items.push({"id": select.value, "quantity": 1});
        }
    }

    const combinedItems = (items = []) => {
     const res = items.reduce((acc, obj) => {
        let found = false;
        for (let i = 0; i < acc.length; i++) {
           if (acc[i].id === obj.id) {
              found = true;
              acc[i].quantity++;
           };
        }
        if (!found) {
           obj.quantity = 1;
           acc.push(obj);
        }
        return acc;
     }, []);
     return res;
    }
    items = combinedItems(items);
    
  }
  
  const data = {
  	items: items
  }
  //console.log(data);
  if(items.length){
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', false);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        //window.location.href = '/checkout';
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
          detail: {
            quantity: 1
          }
        }));
          
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         bubbles: true
        }));
        
        if(form.find('.discountCode').length || discount_codes.length){ 
          apply_discount_code(form,totalQty);  
        }

        if($('.bundle-wrapper-new').length){
          $('.bundle-wrapper-new .custom-count').val(1);
          $('.bundle-wrapper-new .item-info .qty-wrapper').removeClass('active').hide();
          $('.bundle-wrapper-new .item-info .Button.active').show().prop('disabled',false);
          $('.bundle-wrapper-new .bundle-list .tab').removeClass('active').first().click();
          stickSlide.flickity( 'select', 0);
          setStick();
        }

        document.dispatchEvent(new CustomEvent('product-added'));
        
      }
    };
    xhr.send(JSON.stringify(data));
  }

}

let atcEvent = (e) => {
  var id = e.target.getAttribute('data-var-id');
  let formData = {
    id : id,
    quantity:1
  };
 fetch('/cart/add.js', {
  method: 'POST',
  headers: {
  'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
  })
  .then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
       bubbles: true,
      detail: {
        quantity: 1
      }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  });

      
}
var atc = document.querySelectorAll('.collection-atc');
atc.forEach((item) => {
  if(!item.closest('.custom-bundle-btn')){
    item.addEventListener('click', atcEvent)
  }
});


// Remove shipping bar when discount code is added.
setInterval(checkDiscount, 1000);
function checkDiscount() {
  var discountAdded = document.querySelector('.docapp-coupon-input--bean-container--bean');
  var shipText = document.getElementById('Cart__ShippingNotice');
  if(discountAdded){
    var discountCode = document.querySelectorAll('.docapp-coupon-input--bean-container--bean-remove')[0].getAttribute('data-code');
    if(discountCode == 'MIJNFAVORIET'){
      if(shipText){
        shipText.style.display = 'none';
      }else{
        shipText.style.display = 'block';
      }
    }
  }else{
    shipText.style.display = 'block';
  }
}

let buttons = document.querySelectorAll('.add-to-cart-link');
buttons.forEach(button => {
  button.addEventListener('click', addTocart);
});

$(window).on('load', function () {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const section = urlParams.get('make-up-routine');
  if(section){
     $('html, body').animate({
        scrollTop: $("div#shopify-section-template--18871117644099__328a5b80-cf37-4c42-a6e6-63968d41372a").offset().top
    }, 400);
  }
   
  });

$('body').on('click', '.collection-top-block .tab', function(){
    var target = $(this).attr('data-target');
    var ele = $(`form#product_form_${target}`).closest('section');
    if($('body.product-page').length){
      $('html, body').animate({
          scrollTop: ele.offset().top - $('#section-header').innerHeight() - 10
      }, 1000);
    }else{
      $('html, body').animate({
          scrollTop: $("div[data-handle='"+target+"']").offset().top - $('#section-header').innerHeight() - 10
      }, 1000);
    }

});

if(window.innerWidth < 749){
  $('.icons-bar.main-carousel').flickity({
    autoPlay: 4000,
    pageDots: false,
    cellAlign: 'center',
    wrapAround: true,
    prevNextButtons: false
  });
}

function openKlaviyo(formId) {
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', formId]);  
}

var urlParams = new URLSearchParams(window.location.search);
var showPopup = urlParams.get('showPopup'); // true
if(showPopup){
    console.log(showPopup, 'showPopup');
    toggleModal('custom-modal');
}

$('body').on('change', '.bundle-wrapper .select-input', function(){ 
  var av = $('.select-input option[available="false"]:checked');
  var avBtnText = $('#add-to-cart-link').attr('data-btn-text');
  var soldBtnText = $('#add-to-cart-link').attr('data-sold-text');
  console.log('yees', av.length);
  if(av.length > 0){
     $('#add-to-cart-link').text(soldBtnText).prop('disabled', true);
  }else{
     $('#add-to-cart-link').text(avBtnText).prop('disabled', false);
  }
});


/* New Bundle Design JS Start */
var stickSlide = $('.bundle-wrapper-new .tabs').flickity({
  draggable: true,
  prevNextButtons: false,
  pageDots: false,
  cellAlign: 'left',
  wrapAround: false,
}); 

$('body').on('click', '.bundle-wrapper-new .how-many-stick .tab', function(){
  if($(this).hasClass('active')){
    return;
  }
  $('.how-many-stick .tab').removeClass('active')
  $(this).addClass('active');
  $('.bundle-wrapper-new .how-many-stick .tab').attr('data-active-stick', $(this).attr('data-index'));
  if(parseInt($(this).attr('data-index')) >= 3){
    $('.img-wrap').attr('data-images', $(this).attr('data-index'));
  }
  var imagesCount = 0;
  $('.qty-wrapper.active .custom-count').each(function(){
      var count = parseInt($(this).val());
      imagesCount += count;
  });  
  var rem = parseInt($(this).attr('data-index')) - imagesCount;
  //console.log(rem, 'rem');
    $('.img-wrap .default-svg').remove();
    for(i=1;i<=rem;i++){
      $('.img-wrap').append(`<img class="default-svg" src="https://cdn.shopify.com/s/files/1/0664/7896/4955/files/01-2_Rosalyne_sticks_icon_final.svg?v=1730206621" width="80">`);
    }
    
    if(imagesCount > parseInt($(this).attr('data-index'))){
      $('.qty-wrapper.active').last().removeClass('active').hide().prev().prop('disabled', false).show();
      setStick();
    }
    //$('.qty-wrapper').removeClass('active').hide();
    //$('.item-info button[type="button"]').prop('disabled', false).show();

    $('.bundle-wrapper-new').closest('section').find('.ProductForm__BuyButtons').addClass('active');
  
});

function addSticks(){
  var svg = `<svg class="{{ icon_class }}" role="presentation" viewBox="0 0 16 16">
      <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <path d="M8,1 L8,15"></path>
        <path d="M1,8 L15,8"></path>
      </g>
    </svg>`;
  
}

function addImage(){
  $('.img-wrap').html('');
  var imagesCount = 0;
  var selected_stick_count = parseInt($('.bundle-list .tab.active').attr('data-index'));
  if($('.qty-wrapper.active .custom-count').length){
    
    $('.qty-wrapper.active .custom-count').each(function(){
      var count = parseInt($(this).val());
      imagesCount += count;
      var i;
      var img = $(this).closest('.item').find('.item-img img').attr("src");
      for(i=1;i<=count;i++){
        $('.img-wrap').append(`<img src="${img}" width="80">`);
      }
    });
  }else{
     //$('.img-wrap').html($('.default-img').html());
  }

  if(imagesCount <= selected_stick_count){
    var rem = selected_stick_count - imagesCount;
    //console.log(rem, 'rem', selected_stick_count, 'selected_stick_count', imagesCount, 'imagesCount');
    for(i=1;i<=rem;i++){
      $('.img-wrap').append(`<img class="default-svg" src="https://cdn.shopify.com/s/files/1/0664/7896/4955/files/01-2_Rosalyne_sticks_icon_final.svg?v=1730206621" width="80">`);
    }
  }
  
  if(selected_stick_count >= 3){
    $('.img-wrap').attr('data-images', selected_stick_count);
  }

}
 
function setStick(){ 
  var count = 0;
  //var maxCount = $('.bundle-list').length;
  var maxCount = $('.bundle-list').last().find('.tab').attr('data-index');
  var maxStick = parseInt($('.how-many-stick .tab').first().attr('data-active-stick'));
  
  $('.bundle-wrapper-new .qty-wrapper.active .custom-count').map(function(i,v){
    count += +v.value;
  }); 

  var remainCount = maxCount - count;

  $('.bundle-wrapper-new .qty-wrapper .custom-count').attr('max',remainCount);
  
  //var active_stick =  parseInt($('.bundle-list .tab').length);
  var active_stick =  parseInt($('.bundle-list').last().find('.tab').attr('data-index'));
  if(count && count > maxStick ){
    $('.how-many-stick .tab').removeClass('active');
    $('.how-many-stick .tab[data-index="'+count+'"]').addClass('active');
  }
  
  if(count && count <=3 && maxCount > 3  ){
    stickSlide.flickity( 'select', (count-1));
  }else{
   //stickSlide.flickity( 'select', 0);
  }
  
  //console.log(count, 'count');
  //$('#discountCode').val('BUNDEL3');
  switch (count) {
    case 2:
      $('#discountCode').val(discount_codes[1]);
      break;
    case 3:
      $('#discountCode').val(discount_codes[2]);
      break;
    case 4:
      $('#discountCode').val(discount_codes[3]);
      break;
    case 5:
      $('#discountCode').val(discount_codes[4]);
      break;
  }

  if($('.hide-prices-discounts').length){
      $('#discountCode').val('');
  }
  
  if(count == active_stick){
    $('.bundle-wrapper-new .Button.active[type="button"]').prop('disabled', true);
  }else{
    $('.bundle-wrapper-new .Button.active[type="button"]').prop('disabled', false);
  }
  addImage();
  $('.bundle-wrapper-new').closest('section').find('.ProductForm__BuyButtons').addClass('active');
}

$('body').on('click', '.bundle-wrapper-new .Button.active[type="button"]', function(){
  if(+$(this).next('.qty-wrapper').find('.custom-count').attr('max') > 0){
    $(this).hide().next('.qty-wrapper').addClass('active').show();
  }
  setStick();
});

$('body').on('click', '.bundle-wrapper-new .plus', function(){
  var maxCount = $('.bundle-wrapper-new .qty-wrapper .custom-count').length;
  var value = parseInt($(this).prev('input').val()) + 1;
  var max = parseInt($(this).prev('input').attr('max'));
  if(value <= maxCount && max > 0){
    $(this).prev('input').val(value);
  }
  setStick();
});

$('body').on('click', '.bundle-wrapper-new .minus', function(){
   var value = parseInt($(this).next('input').val()) - 1;
   if(value > 0){
     $(this).next('input').val(value);
   }else{
     $(this).closest('.qty-wrapper').removeClass('active').hide().closest('.item-info').find('.Button.active').show();
   }
   setStick();
});

$('body').on('click', '.bundle-wrapper-new .item-title a, .bundle-wrapper-new .item-img img', function(e){
  e.preventDefault();
  var id = $(this).attr('data-img-id');
  var title = $(this).attr('var-title');
  $('.Product__SlideshowNavScroller a[data-media-id="'+id+'"] img').click();
  $('a.Product__SlideshowNavImage').hide();
  $('a.Product__SlideshowNavImage[alt="'+title+'"]').show();
});

let active_product = window.location.href.split('#');
if(active_product.length > 1 && $('.bundle-wrapper-new').length){
  active_product = active_product.pop();
  active_product = decodeURI(active_product);
  console.log(active_product, 'active_product');
  $('.bundle-wrapper-new .item-title [var-title="'+active_product+'"]').click();
}

/* New Bundle Design JS End */

/* Quiz custom add to cart start */
//if($('body.page-quiz-lp').length || $('body.page-quiz').length){
  // Function to handle messages from the iframe
  window.addEventListener('message', (event) => {
      // Verify the origin of the message
      if (event.origin !== "https://admin.revenuehunt.com") {
          console.warn("Blocked message from untrusted origin:", event.origin);
          return;
      }
  
      // Validate and process the data
      const data = event.data;
      if (data && data.action === "callAjax" && data.id) {
        var found_in_cart = 0;
  
        $.ajax({
          url: '/cart.js',
          method: 'GET',
          dataType: 'json',
          async: false, // Synchronous behavior (not recommended)
          success: function(cart) {
            if (cart.items.some(e => e.id == data.id)) {
              found_in_cart = 1;
            }
          },
          error: function(xhr, status, error) {
            console.error('Error fetching cart:', error);
          }
        });
        
        console.log('Found in cart:', found_in_cart);
  
          if(found_in_cart){ console.log('opencart');
            openCart();
          }else{ console.log('sendAjaxRequest');
            sendAjaxRequest(data.id);
          }
      } else {
          //console.error("Invalid message received:", data);
      }
  });
  
  // The AJAX request function
  function sendAjaxRequest(id) {
      console.log(`AJAX request initiated from iframe with ID: ${id}`);
      var sendData = {
        id : id,
        quantity:1
      };
     fetch('/cart/add.js', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify(sendData)
      })
      .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
          detail: {
            quantity: 1
          }
        }));
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      });
  }
  
  function openCart(){
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
       bubbles: true,
      detail: {
        quantity: 1
      }
    }));
    
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
  
//}
/* Quiz custom add to cart end */


$('.video-section-content .play-icon-svg').on('click', function () {
    $(this).hide(); // Hide the play icon
    var video = $(this).siblings('video')[0]; 
    if (video) {
        video.play();
    }
});

// $('.video-section-content video').on('click', function () {
//     $(this).closest('section').find('.icon-play').hide();
//     if (this.paused) {
//         this.play(); 
//     } else {
//         this.pause(); 
//     }
// });

currencyFormat = (function () {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase


  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;


    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";


      if (isNaN(number) || number === null) {
        return 0;
      }


      number = (number / 100.0).toFixed(precision);


      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";


      return dollarsAmount + centsAmount;
    }


    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }


    return formatString.replace(placeholderRegex, value);
  }


  return {
    formatMoney: formatMoney,
  };
})();


$('body').on('click', '.variants.custom-links a', function(e){
  e.preventDefault();
  e.stopPropagation();
  $('.variants.custom-links a').removeClass('active');
  $(this).addClass('active');
  var id = $(this).attr('data-id');
  var price = $(this).attr('data-price');
  console.log('here');
  var img = $(this).attr('data-img');
  $(this).closest('.ProductItem').find('.collection-atc').attr('data-var-id', id);
  $(this).closest('.ProductItem').find('.collection-atc span').attr('data-var-id', id);
  if($(this).parent('.custom-links').hasClass('moisturizer-custom-link')){
  var cp_price = $(this).attr('data-cp-price');
  if(!cp_price){
    $(this).closest('.ProductItem').find('.price-highlight-text').removeClass('Price--highlight').text(currencyFormat.formatMoney(price,theme.moneyFormat));
    $(this).closest('.ProductItem').find('.price-cp-text').text('').hide();

  }else{
    $(this).closest('.ProductItem').find('.ProductItem__Price:first').addClass('Price--highlight');
    $(this).closest('.ProductItem').find('.price-cp-text').text('').show();
     $(this).closest('.ProductItem').find('.ProductItem__Price').text(currencyFormat.formatMoney(price,theme.moneyFormat));
  }
  
  }else{
   $(this).closest('.ProductItem').find('.ProductItem__Price').text(currencyFormat.formatMoney(price,theme.moneyFormat));
  }

  $(this).closest('.ProductItem').find('.ProductItem__Image').attr('src', img);
});

if(!document.body.classList.contains('page-pro-age-make-up-sticks')){
  
  ['click', 'touchend'].forEach(eventType => {
    document.body.addEventListener(eventType, function(e) {
      const checkoutButton = e.target.closest('.Cart__Checkout');
      if (checkoutButton) {
        const acceptTerms = document.getElementById('accept-terms');
        if (acceptTerms && !acceptTerms.checked) {
          e.preventDefault();
          e.stopPropagation();
          console.log('checkout stop');
  
          const acceptError = document.querySelector('.accept-error');
          if (acceptError) {
            acceptError.style.display = 'block';
          }
        } else {
          const acceptError = document.querySelector('.accept-error');
          if (acceptError) {
            acceptError.style.display = 'none';
          }
        }
      }
    });
  });
  
  // Handle checkbox change
  document.body.addEventListener('change', function(e) {
    if (e.target.id === 'accept-terms') {
      const checkoutButton = document.querySelector('.Cart__Checkout');
      const acceptError = document.querySelector('.accept-error');
      if (e.target.checked) {
        if (checkoutButton) checkoutButton.classList.remove('disabled');
        if (acceptError) acceptError.style.display = 'none';
      } else {
        if (checkoutButton) checkoutButton.classList.add('disabled');
      }
    }
  });

}

var landing_page_slider = $('.custom-image-text .images');
$.each(landing_page_slider, function(i,v){
  if(v.children.length > 1){
    $(this).flickity({
      autoPlay: 5000,
      pageDots: true,
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: false,
      adaptiveHeight: true
    });
  }
});

if($('.ship-gift-bar').length){
  
  /* Ship & gift JS Start */
function remove_items(data){
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({updates: data })
  })
  .then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
     bubbles: true
    }));
  })
  .catch((error) => {
    console.error('Error:', error);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
     bubbles: true
    }));
  });
}

function add_items(data){
  const xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/add.js', false);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const response = JSON.parse(xhr.responseText);
        
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
       bubbles: true
      }));
    }
  };
  xhr.send(JSON.stringify(data));
}

function check_gifts(){
    var gift_1_id = $('.Drawer__Container .gift-1').attr('data-id');
    var gift_2_id = $('.Drawer__Container .gift-2').attr('data-id');

    var gift_1_added_to_cart = $('.CartItem.gift-1-added');
    var gift_2_added_to_cart = $('.CartItem.gift-2-added');
  
    var items = [];
    if(gift_1_id && !gift_1_added_to_cart.length){
      items.push({"id": gift_1_id, "quantity": "1", "properties":{"__gift_c_item": 1}});
    }
    if(gift_2_id && !gift_2_added_to_cart.length){
      items.push({"id": gift_2_id, "quantity": "1", "properties":{"__gift_c_item": 1}});
    }
    const gifts = {
    	items: items
    }

    let remove_ids = [];
    var remove_item = {};
  
    if(!gift_1_id && gift_1_added_to_cart.length){  
      var gift_1_cart_id = gift_1_added_to_cart.attr('data-id');
      remove_ids.push(gift_1_cart_id);
    }

    if(!gift_2_id && gift_2_added_to_cart.length){  
      var gift_2_cart_id = gift_2_added_to_cart.attr('data-id');
      remove_ids.push(gift_2_cart_id);
    }

    remove_ids.forEach(id => {
      remove_item[id] = 0;
    });
  
    let item_has_prop_but_not_in_gifts = $('.Drawer__Container .has-gift-property').not('.gift-1-added').not('.gift-2-added');
    if(item_has_prop_but_not_in_gifts.length){
      var item_id = item_has_prop_but_not_in_gifts.attr('data-id');
      if(item_id && item_id != '')
        remove_ids.push(item_id);
    }

    if(!$.isEmptyObject(remove_item)){
       console.log(remove_item, 'remove_item');
      remove_items(remove_item);
    }
    
   
    if(items.length){
       console.log(gifts, 'added gifts');
      add_items(gifts);
    }

    // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    //  bubbles: true
    // }));
}

document.addEventListener('product-added', function(){
    console.log('product-added event');
    setTimeout(function(){
      check_gifts();
    }, 4000);
});

document.addEventListener('cart-updated', function(){
  console.log('cart-updated event');
   setTimeout(function(){
      console.log('check gifts start');
      check_gifts();
    });
});

check_gifts();

$('body').on('change', '.item-variants select', function(){
   var swap_id = $(this).val();
   var remove_id = $(this).closest('.CartItem').attr('data-id');
   if(swap_id != remove_id){
     console.log(swap_id, remove_id);
     var remove_item = {};
     remove_item[remove_id] = 0;
     
     remove_items(remove_item);
     
     add_items({
    	items: [{"id":swap_id, "quantity":1, "properties":{"__gift_c_item": 1}}]
     });
     
   }
    
});

  
}
/* Ship & gift JS End */


let dots = [];
$('.group-dot').each(function(i,v){
    dots.push($(this).html().trim());
});

$('.group-featured-product').wrapAll(`<div class="page-width"><div class="group-featured-wrapper"></div></div>`);

if(window.innerWidth < 750){
  if($('.group-featured-wrapper').length){
    $('.group-featured-wrapper').slick({
      dots: true,
      customPaging : function(slider, i) {
        return `${dots[i]}`;
      },
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.02,
      slidesToScroll: 1
    });
  }
}

  (function () {
    const ua = navigator.userAgent;

    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);

    if (isIOS && isSafari) {
      document.documentElement.classList.add('ios-safari');
    }
  })();